import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';
import { demoEdgeMockEdgeControllers } from '../../../../mocks/demoEdgeMockEdgeControllers';
import { demoEdgeMockPlazaDetails } from '../../../../mocks/demoEdgeMockPlazaDetails';
import { mockChargingStations } from '../../../../mocks/demoEdgeMockChargers';
import './_styles.scss';
import DemoEdgeStatusBadge from '../../../../shared/components/DemoEdgeStatusBadge/DemoEdgeStatusBadge';

const DemoEdgePlazaInfoPanel = ({ edgeControllerId }) => {
  const edgeController = demoEdgeMockEdgeControllers.find((ec) => ec.edgeControllerId === edgeControllerId);
  const plazaId = edgeController?.plazaId;
  const plazaName = edgeController?.plazaName;

  if (!plazaId) {
    return (
      <div className="plaza-info-panel">
        <Card>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              Plaza Information
            </Typography>
            <div className="no-plaza-message">
              <Typography variant="body1" color="textSecondary">
                No plaza assigned to this Edge Controller.
              </Typography>
              <Typography variant="body2" color="textSecondary" style={{ marginTop: 8 }}>
                Edge Controllers must be assigned to a plaza to monitor charging activities.
              </Typography>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  const plazaDetails = demoEdgeMockPlazaDetails[plazaId] || {};
  const chargingStations = mockChargingStations[plazaId] || [];

  const getStatusClassName = (status) => {
    const statusMap = {
      NOT_CONNECTED: 'status-available',
      CONNECTED_CHARGING: 'status-charging',
      FAULTED: 'status-faulted',
      CONNECTED_NOT_CHARGING: 'status-available',
      UNKNOWN: 'status-unknown',
      RESERVED_CABLE_DISCONNECTED: 'status-available',
    };
    return statusMap[status] || 'status-unknown';
  };

  const getStatusLabel = (status) => {
    const labelMap = {
      NOT_CONNECTED: 'Cable Disconnected',
      CONNECTED_CHARGING: 'Charging',
      FAULTED: 'Faulted',
      CONNECTED_NOT_CHARGING: 'Cable Connected, Not Charging',
      UNKNOWN: 'Unknown',
      RESERVED_CABLE_DISCONNECTED: 'Cable Disconnected, Reserved',
    };
    return labelMap[status] || status;
  };

  return (
    <div className="plaza-info-panel">
      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Plaza Information
          </Typography>

          <div className="plaza-info-grid">
            <div className="info-row">
              <span className="info-label">Name:</span>
              <span className="info-value">{plazaName || 'N/A'}</span>
            </div>

            <div className="info-row">
              <span className="info-label">Address:</span>
              <span className="info-value">{plazaDetails.address || 'N/A'}</span>
            </div>

            <div className="info-row">
              <span className="info-label">Total Chargers:</span>
              <span className="info-value">{plazaDetails.totalChargers || 0}</span>
            </div>

            <div className="info-row">
              <span className="info-label">Available:</span>
              <span className="info-value">{plazaDetails.availableChargers || 0}</span>
            </div>

            <div className="info-row">
              <span className="info-label">Algorithm:</span>
              <span className="info-value">{plazaDetails.algorithm || 'N/A'}</span>
            </div>

            <div className="info-row">
              <span className="info-label">Edge Controller:</span>
              <span className="info-value info-value-status configured-properly">Configured Properly</span>
            </div>
          </div>

          <div className="charging-stations-section">
            <Typography variant="subtitle1" gutterBottom style={{ marginTop: 24, fontWeight: 500 }}>
              Charging Stations
            </Typography>
            {chargingStations.length > 0 ? (
              <div className="charging-stations-list">
                {chargingStations.map((station) => (
                  <div key={station.id} className="charger-item">
                    <div className="charger-info">
                      <div className="charger-name">{station.name}</div>
                      <div className="charger-id">{station.id}</div>
                    </div>
                    <DemoEdgeStatusBadge status={getStatusLabel(station.status)} statusClassName={getStatusClassName(station.status)} />
                  </div>
                ))}
              </div>
            ) : (
              <Typography variant="body2" color="textSecondary">
                No charging stations assigned to this plaza.
              </Typography>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default DemoEdgePlazaInfoPanel;
